module.exports = __webpack_public_path__ + "static/media/435746596.5489ceb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AlliedHealth/435746596.jpg
// module id = 636
// module chunks = 0